import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { dataStorageKeywords } from 'src/utils/properties.utils';

function setEncryptedLocalStorageData(
  name: string,
  value: string
): Promise<void> {
  return new Promise((resolve) => {
    const encryptedText = CryptoJS.AES.encrypt(value, 'secret-key').toString();
    localStorage.setItem(name, encryptedText);
    resolve();
  });
}

function getEncryptedLocalStorageData(name: string): Promise<string | null> {
  return new Promise((resolve) => {
    const storedEncryptedValue = localStorage.getItem(name);
    if (storedEncryptedValue) {
      const bytes = CryptoJS.AES.decrypt(storedEncryptedValue, 'secret-key');
      const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
      resolve(decryptedValue);
    } else {
      resolve(null);
    }
  });
}

function clearLocalStorage(): Promise<void> {
  return new Promise((resolve) => {
    localStorage.clear();
    resolve();
  });
}

function clearAllCookies(): Promise<void> {
  return new Promise((resolve) => {
    Cookies.remove(dataStorageKeywords.ACCESS_TOKEN);
    Cookies.remove(dataStorageKeywords.REFRESH_TOKEN);
    Cookies.remove(dataStorageKeywords.USER_ID);
    Cookies.remove(dataStorageKeywords.COMPANY_ID);
  });
}

export {
  setEncryptedLocalStorageData,
  getEncryptedLocalStorageData,
  clearLocalStorage,
  clearAllCookies,
};
